import { useEffect, useState } from "react"
import BuildingBlocksDTO, { TrainerGanttRow } from "../../DTO/BuildingBlocksDTO"
import { EventDTO } from "../../DTO/EventDTO"
import './TrainersGantt.scss'

export default function TrainersGantt(props: {
  buildingBlocksDTO: BuildingBlocksDTO,
  items: EventDTO[],
}) {
  const [items, setItems] = useState<TrainerGanttRow[]>([])
  useEffect(() => {
    setItems(props.buildingBlocksDTO.getTrainersGantt(props.items))
  }, [props.buildingBlocksDTO, props.items, props.items.length])
  return (
    <>
      <table className='TrainersGantt'>
        <tbody>
          {
            items.map((item, index) => {
              return <tr
                key={item.key}
              >
                <td className='TrainerGanttTrainerName'>
                  <button className="w3-button" onClick={item.onClick}>{item.name}</button>
                </td>
                {
                  item.cells.map((cell, index) => {
                    return <td
                      key={index}
                      className={cell.className}
                      onClick={cell.onClick}
                    >
                      <div className="TrainerGanttHoverDisplay">
                        <b>{cell.displayName}</b>
                        
                        {
                          cell.hoverContent.map((hoverContent, index) => {
                            return <button
                              key={index}
                              className={`w3-button allowLineBreak ${hoverContent.className}`}
                              onClick={hoverContent.onClick}
                            >
                              {hoverContent.displayName}
                            </button>
                          })
                        }
                        
                      </div>
                    </td>
                  })
                }
              </tr>
            })
          }
        </tbody>
      </table>
    </>
  )
}
